import { Outlet, Route } from "react-router-dom";

import { ShowProvider } from "../../../providers";
import { PariList } from "../Pari/List/Pari-List";
import { LeonAList } from "../LeonA/List/LeonA-List";
import { LeonBList } from "../LeonB/List/LeonB-List";
import { RusstatList } from "../Russtat/List/Russtat-List";
import { ClubsList } from "../Russtat/Clubs-List";
import { PlayersList } from "../Russtat/Players-List";

const mappingRoutes = [
  <Route key={"mapping"} path="mapping" element={<Outlet />}>
    <Route
      key={"pari"}
      path="pari"
      element={
        <ShowProvider>
          <PariList />
        </ShowProvider>
      }
    />
    <Route
      key={"leon_a"}
      path="leon_a"
      element={
        <ShowProvider>
          <LeonAList />
        </ShowProvider>
      }
    />
    <Route
      key={"leon_b"}
      path="leon_b"
      element={
        <ShowProvider>
          <LeonBList />
        </ShowProvider>
      }
    />
    <Route
      key={"russtat"}
      path="russtat"
      element={
        <ShowProvider>
          <RusstatList />
        </ShowProvider>
      }
    />
    <Route
      key={"clubs-russtat"}
      path="russtat/clubs/:fnlLeagueId/:fnlSeasonId"
      element={
        <ShowProvider>
          <ClubsList />
        </ShowProvider>
      }
    />
    <Route
      key={"players-russtat"}
      path="russtat/clubs/:fnlLeagueId/:fnlSeasonId/:fnlTeamId"
      element={
        <ShowProvider>
          <PlayersList />
        </ShowProvider>
      }
    />
  </Route>,
];

export const MAPPING_ROUTES = mappingRoutes.map((route) => route);
